import utils from "../utils";
import { BaseApi, ApiResponse } from "../utils/request";

// SMS 相关类型定义
// 注：后端 /api/sms/send_message 实际不读 type 字段，仅按 phone + countryId 下发；
// type 保留是为了 SMS 验证侧或将来按类型分流，前端按业务场景透传。
export interface SendSmsRequest {
  phone: string;
  type: "register" | "login" | "reset_password" | "verify";
}

export interface SendSmsResponse {
  success: boolean;
  message?: string;
  code?: string;
}

export interface SmsVerifyRequest {
  phone: string;
  code: string;
  type: "register" | "login" | "reset_password" | "verify";
}

export interface SmsVerifyResponse {
  success: boolean;
  message?: string;
  verified: boolean;
}

/**
 * SMS API 类
 * 继承 BaseApi，提供短信相关的 API 接口
 */
export class SmsApi extends BaseApi {
  constructor() {
    super();
  }

  /**
   * 发送短信验证码
   * @param data 发送短信请求数据
   * @returns Promise<ApiResponse<SendSmsResponse>>
   */
  async sendMessage(
    data: SendSmsRequest,
    countryIdOverride?: string
  ): Promise<ApiResponse<SendSmsResponse>> {
    return this.post<SendSmsResponse>("/api/sms/send_message", {
      ...data,
      countryId: countryIdOverride ?? utils.getObject("countryId"),
    });
  }

  /**
   * 验证短信验证码
   * @param data 验证短信请求数据
   * @returns Promise<ApiResponse<SmsVerifyResponse>>
   */
  async verifyCode(
    data: SmsVerifyRequest
  ): Promise<ApiResponse<SmsVerifyResponse>> {
    return this.post<SmsVerifyResponse>("/api/sms/verify_code", {
      ...data,
      countryId: utils.getObject("countryId"),
    });
  }

  /**
   * 检查短信发送频率限制
   * @param mobile 手机号
   * @returns Promise<ApiResponse<{ canSend: boolean; nextSendTime?: number }>>
   */
  async checkRateLimit(
    phone: string
  ): Promise<ApiResponse<{ canSend: boolean; nextSendTime?: number }>> {
    return this.post<{ canSend: boolean; nextSendTime?: number }>(
      "/api/sms/check_rate_limit",
      { phone }
    );
  }
}

export const smsApi = new SmsApi();

export const sendSmsCode = (
  phone: string,
  type: SendSmsRequest["type"],
  countryId?: string
) => smsApi.sendMessage({ phone, type }, countryId);

export const verifySmsCode = (
  phone: string,
  code: string,
  type: SmsVerifyRequest["type"]
) => smsApi.verifyCode({ phone, code, type });

export const checkSmsRateLimit = (phone: string) =>
  smsApi.checkRateLimit(phone);
